/**
 * Inline MSW response for the tripwires admin view (/apollo/tripwires). Spread into the ENV-wide
 * INLINE_RESPONSES map. One tripped and one armed, so the table renders both badge colours and the
 * Re-arm button (which only shows on a tripped row).
 */
export const TRIPWIRES_INLINE_RESPONSES = {
  "/apollo/tripwires/get-all-tripwires": [
    {
      tripwireId: "9b1f4c22-6d3e-4a91-8f77-2c5ad0e41b30",
      tripwireName: "classitplus",
      consecutiveFailures: 3,
      trippedAt: "2026-08-15T19:11:33Z",
      trippedReason:
        "Couldn't get the redirectUrl from password challenge request",
      lastFailureAt: "2026-08-15T19:11:33Z",
      lastFailureMessage:
        "Couldn't get the redirectUrl from password challenge request",
      lastSuccessAt: "2026-08-14T22:04:18Z",
      resetAt: undefined,
      resetBy: undefined,
    },
    {
      tripwireId: "3f8c1a07-52bd-4e6a-9c14-77aa9e2d5b81",
      tripwireName: "tm4web",
      consecutiveFailures: 0,
      trippedAt: undefined,
      trippedReason: undefined,
      lastFailureAt: undefined,
      lastFailureMessage: undefined,
      lastSuccessAt: "2026-08-16T06:42:09Z",
      resetAt: "2026-07-02T17:30:00Z",
      resetBy: "chris@freightsimple.com",
    },
  ],
};
